import React, { useCallback, useEffect, useMemo, useState } from "react";

import FormBtn from "app/Components/CommanComponents/FormBtn";
import { confirmAlert } from "react-confirm-alert";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import InputError from "app/Components/_form/InputError/InputError";
import {
  siteTypeList,
  siteTypeObj,
} from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/Sites/Sites";
import { Card, Col, Row, FormGroup, Button } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import Label from "app/Components/_form/Label/Label";
import ViewBasicDetailsComponent from "./Component/ViewBasicDetailsComponent";
import { ContractorPersonActions, contractorPersonFormLabel } from "./Constant";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import toastr from "toastr";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";

import { DDMMYYYYFormat, disableFutureDate, isAfter } from "app/_helpers/dateHelper";

import {
  getContractorPersonById,
  updateContractorPersonCurrentLocation,
} from "app/_services/UserManagement/ContractorPersonService";
import {
  WidgetBox,
  initialMedicalValidation,
  initialTrainingValidation,
} from "../Employee/Constant";
import LocationHistoryList from "../Employee/Component/LocationHistoryList";
import InitialMedicalForm from "../Employee/Component/InitialMedicalForm";
import InitialTrainingForm from "../Employee/Component/InitialTrainingForm";
import InitialLocationForm from "../Employee/Component/InitialLocationForm";
import {
  getActiveContractor,
  getContractor,
} from "app/_services/Contractor/ContractorService";
import ViewLocationForm from "../Employee/Component/ViewLocationForm";
import ConfirmationModal from "../Employee/Component/ConfimationModal";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

function ContractorPersonLocationForm() {
  const [form, setForm] = useState({});
  const [staticForm, setStaticForm] = useState({});
  const [error, setError] = useState({});
  const { id } = useParams();
  const [siteList, setSiteList] = useState([]);
  const [initialForm, setInitialForm] = useState({});
  const [contractorList, setContractorList] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const history = useHistory();
  // Site History Modal
  const [siteHistoryList, setSiteHistoryList] = useState([]);
  const [isDisable, setIsDisable] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState({});
  const [loading, setLoading] = useState(false);

  const getAllContractorList = async () => {
    let response = await getActiveContractor();
    if (!response?.data || !response?.status) return;
    setContractorList(response.data);
  };

  /***************** useMemo ********************/
  const showTraining = useMemo(
    () => form.siteType === 3,
    // initialForm.siteType !== 3 &&
    // !form?.basicTrainingCompletionDate,
    [form.siteType]
  );

  const showMedical = useMemo(
    () =>
      form.siteType === 3 &&
      // initialForm.siteType !== 3 &&
      !form?.lastIMEDate,
    // !form?.lastPMEDate,
    [form?.lastIMEDate, form.siteType]
  );

  useEffect(() => {
    if (form?.currentWorkLocation === initialForm?.currentWorkLocation) {
      setForm((prev) => ({
        ...prev,
        trainingEligibility: initialForm?.trainingEligibility,
        trainingDesignation: initialForm?.trainingDesignation,
        specialMedicalExamEligibility: initialForm?.specialMedicalExamEligibility,
        specialMedicalExamCategory: initialForm?.specialMedicalExamCategory,
      }));
      setIsDisable(true);
    } else setIsDisable(false);
  }, [
    form?.currentWorkLocation,
    initialForm?.currentWorkLocation,
    initialForm?.specialMedicalExamCategory,
    initialForm?.specialMedicalExamEligibility,
    initialForm?.trainingDesignation,
    initialForm?.trainingEligibility,
  ]);

  /***************** Api Call ********************/
  const getFormData = useCallback(
    async (qq) => {
      getContractorPersonById(id).then((response) => {
        if (!response?.status) {
          history.push("/user-management/contractor-person");
          toastr.error(response?.message || "Something went Wrong");
          return;
        }
        if (!response?.data) return;
        const row = response.data;

        setForm({
          ...row,
          siteType: row?.ehsSite?.siteType || "",
          isPmeDate: row?.lastPMEDate ? true : false,
          isIMEDate: row?.isIMEDate ? true : false,
          pmeDate: row?.lastPMEDate,
          imeDate: row?.lastIMEDate,
        });
        setStaticForm({
          ...row,
          siteType: row?.ehsSite?.siteType || "",
          isPmeDate: row?.lastPMEDate ? true : false,
          pmeDate: row?.lastPMEDate,
        });
        setIsDisable(row?.ehsSite?.siteType === 3 ? true : false);

        setInitialForm({
          ...row,
          siteType: row?.ehsSite?.siteType || "",
          isPmeDate: row?.lastPMEDate ? true : false,
          pmeDate: row?.lastPMEDate,
        });

        setSiteHistoryList([
          {
            ...row,
            sid: 1,
            isPmeDate: row?.lastPMEDate ? true : false,
            isIMEDate: row?.isIMEDate ? true : false,
            imeDate: row?.lastIMEDate,
            pmeDate: row?.lastPMEDate,
            siteName: row?.ehsSite?.name,
            startDateView: row?.startDateAtMines
              ? DDMMYYYYFormat(row?.startDateAtMines)
              : "",
            // endDateView: d.endDate ? DDMMYYYYFormat(d.endDate) : "",
            endDateView:
              row?.employmentStatus === "inActive" && row?.dateOfSeparation
                ? DDMMYYYYFormat(row?.dateOfSeparation)
                : "",

            siteType: row?.ehsSite?.siteType || "",
            siteTypeView: siteTypeObj[row?.ehsSite?.siteType],
            siteId: row?.currentWorkLocation,
            currentWorkLocation: row?.currentWorkLocation,
            startDateAtMines: row?.startDateAtMines,
            startDate: row?.startDateAtMines,
            contractorName: row?.contractors?.contactPerson,
          },
          ...(row?.contractorPersonSiteHistories || []).map((d, i) => ({
            ...d,
            sid: i + 2,
            siteName: d?.ehsSiteForHistory?.name,
            startDateView: d.startDate ? DDMMYYYYFormat(d.startDate) : "",
            endDateView: d.endDate ? DDMMYYYYFormat(d.endDate) : "",
            siteTypeView: siteTypeObj[d?.ehsSiteForHistory?.siteType],
            contractorName: d?.contractor?.contactPerson,
          })),
        ]);
      });
    },
    [id]
  );

  const getAllSiteList = useCallback(async () => {
    let response = await getAllSites("filter[status]=1");
    if (!response?.data || !response?.status) return;

    setSiteList(response.data);
  }, []);

  const onChange = ({ target: { name, value, type, checked } }) => {
    let extraToChange = {};
    if (name === "currentWorkLocation" && value !== form?.currentWorkLocation) {
      if (
        siteList
          .filter((d) => d.siteType === 3)
          .map((d) => d.id)
          .includes(+value)
      ) {
        if (!form?.lastIMEDate && !form?.lastPMEDate) {
          extraToChange.mineTag = "yes";
          extraToChange.trainingEligibility = "";
          extraToChange.trainingDesignation = "";
          // extraToChange.isPmeDate = false;
          // extraToChange.pmeDate = "";
          extraToChange.specialMedicalExamEligibility = "";
          extraToChange.specialMedicalExamCategory = "";
        } else extraToChange.mineTag = "yes";
      } else {
        extraToChange.mineTag = "no";
        // extraToChange.startDateAtMines = "";
      }
    }

    if (name === "siteType" && value !== form?.siteType) {
      extraToChange.currentWorkLocation = "";
      extraToChange.startDateAtMines = "";
      extraToChange.endDateAtMines = "";
      extraToChange.mineTag = "no";
    }

    if (name === "isPmeDate" && value !== form?.isPmeDate) {
      extraToChange.pmeDate = "";
      extraToChange.pmeCertificateNo = "";
      extraToChange.pmeCertificateId = null;
    }

    if (name === "isIMEDate" && value !== form?.isIMEDate) {
      extraToChange.imeDate = "";
      extraToChange.imeCertificateNo = "";
      extraToChange.imeCertificateId = null;
    }

    setForm((prev) => ({
      ...prev,
      ...extraToChange,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  let query = "checkPreviousRecord=true";

  const onSubmit = useCallback(
    async (e, checkExisting = true) => {
      if (e) e.preventDefault();

      let errorObj = {};

      if (form.siteType) {
        if (!form.currentWorkLocation) {
          errorObj["currentWorkLocation"] =
            contractorPersonFormLabel["currentWorkLocation"] + " is Required.";
        }

        // if (form.currentWorkLocation) {
        if (!form.startDateAtMines)
          errorObj["startDateAtMines"] =
            contractorPersonFormLabel["startDateAtMines"] + " is Required.";
        // }

        if (
          form?.dateOfJoining &&
          form?.startDateAtMines &&
          isAfter(form?.dateOfJoining, form?.startDateAtMines)
        ) {
          errorObj["startDateAtMines"] =
            contractorPersonFormLabel["startDateAtMines"] +
            " Can't Before " +
            contractorPersonFormLabel["dateOfJoining"];
        }
      } else {
        errorObj["siteType"] = contractorPersonFormLabel["siteType"] + " is Required.";
      }

      if (!form.contractorId) {
        errorObj["contractorId"] =
          contractorPersonFormLabel["contractorId"] + " is Required.";
      }

      if (showTraining) {
        errorObj = initialTrainingValidation(errorObj, form);
      }

      if (form?.siteType === 3) {
        errorObj = initialMedicalValidation(errorObj, form);
      }
      setError((prev) => ({
        ...errorObj,
      }));

      if (Object.values(errorObj).filter((d) => d !== "").length) return;
      setLoading(true);

      let formObj = JSON.parse(JSON.stringify(form));
      formObj.trainingType = 1;

      // let response = await updateContractorPersonCurrentLocation(id, {
      //   employee: formObj,
      // });
      let response = {};
      if (checkExisting && form.currentWorkLocation !== staticForm.currentWorkLocation) {
        response = await updateContractorPersonCurrentLocation(
          id,
          {
            employee: formObj,
          },
          query
        );
      } else {
        response = await updateContractorPersonCurrentLocation(id, {
          employee: formObj,
        });
      }
      if (response?.data?.existingData) {
        setConfirmMsg(response?.data?.existingData);
        setConfirmation(true);
        setLoading(false);
        return;
      } else {
        setConfirmation(false);
      }

      if (!response?.status) {
        setLoading(false);
        return toastr.error(response?.message);
      }

      setLoading(false);
      toastr.success(response.message || "Success.");
      // push(`/user-management/employee`);
      getFormData();
    },
    [form, getFormData, id, showTraining]
  );

  const confirmationAlert = useCallback(() => {
    confirmAlert({
      title: "Change location",
      message: "Are you sure you want to proceed with location update",
      buttons: [
        {
          label: "Yes",
          onClick: (e) => {
            onSubmit(e, false);
          },
        },
        {
          label: "No",
          onClick: () => {
            setConfirmation(false);
          },
        },
      ],
    });
  }, [onSubmit]);

  const onHideConfirmation = () => {
    setConfirmation(false);
  };
  /*********************** useEffect ***************************/
  useEffect(() => {
    getAllSiteList();
    getAllContractorList();
  }, [getAllSiteList]);

  useEffect(() => {
    if (!id) return;

    getFormData(1);
  }, [getFormData, id]);

  return (
    <Card className="overflow-inherit">
      <Card.Body>
        <Card.Title className="simple-card-title justify-content-between">
          <h3 class="text-capitalize mb-1">Edit location</h3>
          <ContractorPersonActions id={id} form={staticForm} />
        </Card.Title>
        <WidgetBox form={initialForm} />

        <ViewBasicDetailsComponent form={form} />
        <ViewLocationForm isContractorPerson form={initialForm} />

        {isActive ? (
          <>
            {!loading ? (
              <>
                <InitialLocationForm
                  locationTitle={"New Location"}
                  contractorList={contractorList}
                  siteList={siteList}
                  form={form}
                  onChange={onChange}
                  error={error}
                  showContractor
                  showTraining={showTraining}
                  showMedical={showMedical}
                  lgClass={4}
                  isDisable={isDisable}
                />
                {/* {showTraining && (
          <InitialTrainingForm form={form} onChange={onChange} error={error} />
        )}

        {form?.siteType === 3 && (
          <InitialMedicalForm
            showMedical={showMedical}
            form={form}
            onChange={onChange}
            error={error}
          />
        )} */}

                <FormBtn
                  id={id}
                  backBtnTitle={"Cancel"}
                  onSubmit={onSubmit}
                  backOnClick={() => setIsActive(false)}
                />
              </>
            ) : (
              <NetZeroLoader addZIndex={true} />
            )}
          </>
        ) : (
          <div className={"mt-4 text-center"}>
            <Button onClick={history.goBack} variant="secondary" className="mr-2">
              {"Back"}
            </Button>

            <Button onClick={() => setIsActive(true)} variant="primary" className="ml-2">
              {"Move Location"}
            </Button>
          </div>
        )}

        <LocationHistoryList
          employeeType={"contractorPerson"}
          data={siteHistoryList}
          getFormData={getFormData}
          siteList={siteList}
          contractorList={contractorList}
          showContractor
          isContractorPerson
        />
      </Card.Body>
      {!loading ? (
        <ConfirmationModal
          confirmation={confirmation}
          onHideConfirmation={onHideConfirmation}
          confirmMsg={confirmMsg}
          confirmationAlert={confirmationAlert}
          title={"Location Change Confirmation"}
          type={"location"}
          modalFor={"contractor staff"}
          checkMedicalForPending={true}
        ></ConfirmationModal>
      ) : (
        ""
      )}
    </Card>
  );
}

export default ContractorPersonLocationForm;
